import { ForwardedRef, forwardRef } from 'react';
import { AutoFocus } from '../../auto_focus';
import { NotificationAlert } from '../../notification_alert';
import { useFormContext } from './form.context';

export interface FormErrorProps {}

export const CellulaFormError = forwardRef<HTMLDivElement, FormErrorProps>(function CellulaFormError(
	_: FormErrorProps,
	ref: ForwardedRef<HTMLDivElement>,
): JSX.Element | null {
	const formContext = useFormContext();

	if (formContext === undefined) {
		throw new Error('Form.SubmitButton must be used within an Form.Root to access FormContext');
	}

	if (!formContext.submitError) {
		return null;
	}

	return (
		<NotificationAlert variant='danger' ref={ref}>
			<AutoFocus>{formContext.submitError}</AutoFocus>
		</NotificationAlert>
	);
});
